// Module Vuex pour exportVisit
const state = {
  // État du processus d'export
  creating: false,
  readyToDownload: false,
  downloading: false,
  fetchingIds: false,
  
  // Données
  ids: [],
  totalIds: 0,
  
  // Filtres
  filters: {
    hasVisitDate: false,
    visitedFrom: '',
    visitedTo: '',
    hasHorsScaprim: false,
    team: '',
    city: '',
    propertyType: '',
    assistance: '',
    owner: '',
    status: '',
    groupOwner: '',
    unit: '',
    subUnit: '',
    interventionPoint: '',
    controlAnswer: '',
    rentable: '',
    workToBePlanned: '',
    withAppendix: false
  },
  
  // Labels des filtres sélectionnés pour l'affichage
  selectedFiltersLabels: {},
  
  // Données de référence
  teams: [],
  propertyTypes: [],
  assistances: [],
  owners: [],
  groupOwners: [],
  units: [],
  subUnits: [],
  interventionPoints: [],
  controlAnswers: [],
  rentableAnswers: [],
  workToBePlannedAnswers: [],
  
  // État général
  loading: false,
  error: null
}

const mutations = {
  // État du processus
  SET_CREATING(state, creating) {
    state.creating = creating
  },
  SET_READY_TO_DOWNLOAD(state, ready) {
    state.readyToDownload = ready
  },
  SET_DOWNLOADING(state, downloading) {
    state.downloading = downloading
  },
  SET_FETCHING_IDS(state, fetching) {
    state.fetchingIds = fetching
  },
  
  // Données
  SET_IDS(state, ids) {
    state.ids = ids
  },
  SET_TOTAL_IDS(state, total) {
    state.totalIds = total
  },
  
  // Filtres
  SET_FILTER(state, { key, value }) {
    state.filters[key] = value
  },
  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },
  RESET_FILTERS(state) {
    state.filters = {
      hasVisitDate: false,
      visitedFrom: '',
      visitedTo: '',
      hasHorsScaprim: false,
      team: '',
      city: '',
      propertyType: '',
      assistance: '',
      owner: '',
      status: '',
      groupOwner: '',
      unit: '',
      subUnit: '',
      interventionPoint: '',
      controlAnswer: '',
      rentable: '',
      workToBePlanned: '',
      withAppendix: false
    }
  },
  
  // Labels des filtres
  SET_SELECTED_FILTERS_LABELS(state, labels) {
    state.selectedFiltersLabels = labels
  },
  
  // Données de référence
  SET_TEAMS(state, teams) {
    state.teams = teams
  },
  SET_PROPERTY_TYPES(state, types) {
    state.propertyTypes = types
  },
  SET_ASSISTANCES(state, assistances) {
    state.assistances = assistances
  },
  SET_OWNERS(state, owners) {
    state.owners = owners
  },
  SET_GROUP_OWNERS(state, groupOwners) {
    state.groupOwners = groupOwners
  },
  SET_UNITS(state, units) {
    state.units = units
  },
  SET_SUB_UNITS(state, subUnits) {
    state.subUnits = subUnits
  },
  SET_INTERVENTION_POINTS(state, points) {
    state.interventionPoints = points
  },
  SET_CONTROL_ANSWERS(state, answers) {
    state.controlAnswers = answers
  },
  SET_RENTABLE_ANSWERS(state, answers) {
    state.rentableAnswers = answers
  },
  SET_WORK_TO_BE_PLANNED_ANSWERS(state, answers) {
    state.workToBePlannedAnswers = answers
  },
  
  // État général
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  // Actions pour l'état du processus
  setCreating({ commit }, creating) {
    commit('SET_CREATING', creating)
  },
  setReadyToDownload({ commit }, ready) {
    commit('SET_READY_TO_DOWNLOAD', ready)
  },
  setDownloading({ commit }, downloading) {
    commit('SET_DOWNLOADING', downloading)
  },
  setFetchingIds({ commit }, fetching) {
    commit('SET_FETCHING_IDS', fetching)
  },
  
  // Actions pour les données
  setIds({ commit }, ids) {
    commit('SET_IDS', ids)
  },
  setTotalIds({ commit }, total) {
    commit('SET_TOTAL_IDS', total)
  },
  
  // Actions pour les filtres
  updateFilter({ commit }, { key, value }) {
    commit('SET_FILTER', { key, value })
  },
  updateFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },
  resetFilters({ commit }) {
    commit('RESET_FILTERS')
  },
  
  // Actions pour les labels des filtres
  updateSelectedFiltersLabels({ commit }, labels) {
    commit('SET_SELECTED_FILTERS_LABELS', labels)
  },
  
  // Actions pour charger les données de référence
  async loadReferenceData({ commit }) {
    try {
      commit('SET_LOADING', true)
      
      // Simuler le chargement des données de référence
      // En réalité, ces données viendraient d'appels API
      
      const teams = [
        { value: 'team1', label: 'Agence Paris' },
        { value: 'team2', label: 'Agence Lyon' },
        { value: 'team3', label: 'Agence Marseille' }
      ]
      
      const propertyTypes = [
        { value: 'apartment', label: 'Appartement' },
        { value: 'house', label: 'Maison' },
        { value: 'studio', label: 'Studio' }
      ]
      
      const assistances = [
        { value: 'cat1', label: 'Catégorie 1' },
        { value: 'cat2', label: 'Catégorie 2' },
        { value: 'cat3', label: 'Catégorie 3' }
      ]
      
      const owners = [
        { value: 'owner1', label: 'Propriétaire A' },
        { value: 'owner2', label: 'Propriétaire B' }
      ]
      
      const groupOwners = [
        { value: 'group1', label: 'Groupe A' },
        { value: 'group2', label: 'Groupe B' }
      ]
      
      const units = [
        { value: 'unit1', label: 'Unité 1' },
        { value: 'unit2', label: 'Unité 2' }
      ]
      
      const subUnits = [
        { value: 'subunit1', label: 'Sous-unité 1' },
        { value: 'subunit2', label: 'Sous-unité 2' }
      ]
      
      const interventionPoints = [
        { value: 'point1', label: 'Point de contrôle 1', type: 'type1' },
        { value: 'point2', label: 'Point de contrôle 2', type: 'type2' }
      ]
      
      const controlAnswers = [
        { value: 'ok', label: 'Conforme' },
        { value: 'nok', label: 'Non conforme' },
        { value: 'na', label: 'Non applicable' }
      ]
      
      const rentableAnswers = [
        { value: 'immediately', label: 'Immédiatement' },
        { value: 'after_work', label: 'Après travaux' },
        { value: 'not_rentable', label: 'Non relouable' }
      ]
      
      const workToBePlannedAnswers = [
        { value: 'yes', label: 'Oui' },
        { value: 'no', label: 'Non' },
        { value: 'maybe', label: 'À évaluer' }
      ]
      
      // Commit des données
      commit('SET_TEAMS', teams)
      commit('SET_PROPERTY_TYPES', propertyTypes)
      commit('SET_ASSISTANCES', assistances)
      commit('SET_OWNERS', owners)
      commit('SET_GROUP_OWNERS', groupOwners)
      commit('SET_UNITS', units)
      commit('SET_SUB_UNITS', subUnits)
      commit('SET_INTERVENTION_POINTS', interventionPoints)
      commit('SET_CONTROL_ANSWERS', controlAnswers)
      commit('SET_RENTABLE_ANSWERS', rentableAnswers)
      commit('SET_WORK_TO_BE_PLANNED_ANSWERS', workToBePlannedAnswers)
      
    } catch (error) {
      commit('SET_ERROR', error.message)
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  // Action pour soumettre le formulaire et récupérer les IDs
  async submitExportForm({ commit, state }) {
    try {
      commit('SET_FETCHING_IDS', true)
      commit('SET_ERROR', null)
      
      // Simuler l'appel API pour récupérer les IDs des visites
      await new Promise(resolve => setTimeout(resolve, 2000))
      
      // Simuler des résultats
      const totalIds = Math.floor(Math.random() * 100) + 1
      const ids = Array.from({ length: totalIds }, (_, i) => i + 1)
      
      commit('SET_TOTAL_IDS', totalIds)
      commit('SET_IDS', ids)
      
      // Générer les labels des filtres sélectionnés
      const labels = {}
      if (state.filters.team) {
        const team = state.teams.find(t => t.value === state.filters.team)
        if (team) labels['Agence'] = team.label
      }
      if (state.filters.city) {
        labels['Ville'] = state.filters.city
      }
      if (state.filters.visitedFrom && state.filters.visitedTo) {
        labels['Période'] = `${state.filters.visitedFrom} - ${state.filters.visitedTo}`
      }
      
      commit('SET_SELECTED_FILTERS_LABELS', labels)
      
      // Passer en mode création
      commit('SET_CREATING', true)
      
      // Simuler la préparation du téléchargement
      setTimeout(() => {
        commit('SET_READY_TO_DOWNLOAD', true)
      }, 3000)
      
    } catch (error) {
      commit('SET_ERROR', error.message)
    } finally {
      commit('SET_FETCHING_IDS', false)
    }
  },
  
  // Action pour télécharger le fichier ZIP
  async downloadZip({ commit }) {
    try {
      commit('SET_DOWNLOADING', true)
      commit('SET_ERROR', null)
      
      // Simuler le téléchargement
      await new Promise(resolve => setTimeout(resolve, 2000))
      
      // Créer un lien de téléchargement fictif
      const link = document.createElement('a')
      link.href = '#'
      link.download = `export-visites-${new Date().toISOString().split('T')[0]}.zip`
      link.click()
      
      // Réinitialiser l'état après téléchargement
      commit('SET_CREATING', false)
      commit('SET_READY_TO_DOWNLOAD', false)
      commit('SET_DOWNLOADING', false)
      
    } catch (error) {
      commit('SET_ERROR', error.message)
    }
  },
  
  // Action pour annuler le téléchargement
  abortDownload({ commit }) {
    commit('SET_CREATING', false)
    commit('SET_READY_TO_DOWNLOAD', false)
    commit('SET_DOWNLOADING', false)
    commit('SET_FETCHING_IDS', false)
  },
  
  // Actions générales
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
  setError({ commit }, error) {
    commit('SET_ERROR', error)
  }
}

const getters = {
  // État du processus
  creating: state => state.creating,
  readyToDownload: state => state.readyToDownload,
  downloading: state => state.downloading,
  fetchingIds: state => state.fetchingIds,
  
  // Données
  ids: state => state.ids,
  totalIds: state => state.totalIds,
  
  // Filtres
  filters: state => state.filters,
  selectedFiltersLabels: state => state.selectedFiltersLabels,
  
  // Données de référence
  teams: state => state.teams,
  propertyTypes: state => state.propertyTypes,
  assistances: state => state.assistances,
  owners: state => state.owners,
  groupOwners: state => state.groupOwners,
  units: state => state.units,
  subUnits: state => state.subUnits,
  interventionPoints: state => state.interventionPoints,
  controlAnswers: state => state.controlAnswers,
  rentableAnswers: state => state.rentableAnswers,
  workToBePlannedAnswers: state => state.workToBePlannedAnswers,
  
  // État général
  loading: state => state.loading,
  error: state => state.error,
  
  // Getters calculés
  hasActiveFilters: state => {
    return Object.values(state.filters).some(value => {
      if (typeof value === 'boolean') return value
      if (typeof value === 'string') return value.trim() !== ''
      return false
    })
  },
  
  isFormValid: state => {
    // Le formulaire est valide s'il y a au moins un critère de sélection
    return state.filters.hasVisitDate || 
           state.filters.team || 
           state.filters.city || 
           state.filters.propertyType ||
           state.filters.assistance ||
           state.filters.owner ||
           state.filters.status ||
           state.filters.groupOwner ||
           state.filters.unit ||
           state.filters.subUnit ||
           state.filters.interventionPoint ||
           state.filters.controlAnswer ||
           state.filters.rentable ||
           state.filters.workToBePlanned
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
